interface FormatShippingPromoteDescriptionProps {
  t: (key: string, options?: { defaultValue: string, [key: string]: number | string | undefined }) => string
  currency?: string
}

export const formatShippingPromotionDescription = (props: FormatShippingPromoteDescriptionProps) => {
  const { t } = props

  const formatShippingPromoteDescription = (
    minShippingAmount: number,
    minShippingFee: number,
  ) => {
    const nextShippingText = minShippingFee === 0
      ? t('wpCart.getFreeShipping', { defaultValue: '免運' })
      : t('wpCart.nextShippingFee', { fee: `$${minShippingFee.toLocaleString()}`, defaultValue: '運費 {{fee}}' })

    return minShippingAmount > 0
      ? t('wpCart.justMoreToGo', { gap: `$${minShippingAmount.toLocaleString()}`, defaultValue: '差 {{gap}}' }) + ' ' + nextShippingText
      : ''
  }

  const getShippingPromoteDescriptionParts = (
    shippingThresholdGap: number,
    targetShippingFee: number,
  ) => {
    const shippingAmountGap = `$${shippingThresholdGap.toLocaleString()}`
    const nextShippingText = targetShippingFee === 0
      ? t('wpCart.withFreeShipping', { defaultValue: '享免運' })
      : t('wpCart.withShippingDiscount', { fee: `$${targetShippingFee.toLocaleString()}`, defaultValue: '享運費折扣' })

    return {
      shippingAmountGap,
      nextShippingText,
    }
  }

  return {
    formatShippingPromoteDescription,
    getShippingPromoteDescriptionParts,
  }
}
